import update from 'immutability-helper';

const FETCH = 'guides/FETCH';

const DEFAULT_STATE = {
    guides: []
};

export const GuidesReducer = {
    reducer: (state = DEFAULT_STATE, action) => {
        switch (action.type) {
            case FETCH:
                return update(state, {
                    guides: {$set: action.payload}
                });
            default:
                return state;
        }
    },

    set: guides => dispatch => {
        dispatch({type: FETCH, payload: guides});
    }
};


// WEBPACK FOOTER //
// ./src/reducers/guides.reducer.js